import React from 'react';

import FriendsPromo from './friends-promo';
import PrintsPromo from './prints-promo';

import '../../../styles/common/promos/shopping-bar.scss';

const ShoppingBar = (props) => (
  <div className="shopping-bar">
    <PrintsPromo frameCount={4} inShoppingBar={true} />
    <div className="shopping-bar__postcards">
      <FriendsPromo />
    </div>
  </div>
);

export default ShoppingBar;